import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import PropTypes from 'prop-types';

const Filter = ({ handleFilter, filter }) => {
    return (
        <ButtonGroup>
            <Button className={filter === 'all' ? 'bg-secondary' : ''} color="dark" onClick={() => handleFilter('all')}>All</Button>
            <Button className={filter === 'running' ? 'bg-secondary' : ''} color="dark" onClick={() => handleFilter('running')}>Running</Button>
            <Button className={filter === 'completed' ? 'bg-secondary' : ''} color="dark" onClick={() => handleFilter('completed')}>Completed</Button>
        </ButtonGroup>
    );
};

Filter.propTypes = {
    handleFilter: PropTypes.func.isRequired
};

export default Filter;